import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import {
  getClipboardHeaderbar,
  getCodesHeaderbar,
  getDashboardHeaderbar,
  getFinanceHeaderbar,
  getInventoryHeaderbar,
  getLaborHeaderbar,
  getMenuHeaderbar,
  getOnlifeHeaderbar,
  getOrderHeaderbar,
  getReportingHeaderbar,
  getSettingHeaderbar,
} from "../../../helpers";

const Headerbar = ({ type }) => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const { user_details } = useSelector((state) => state.authReducer);
  const [activeMenu, setActiveMenu] = useState("");
  const [activeSubMenu, setActiveSubMenu] = useState("");
  const [activeThirdMenu, setActiveThirdMenu] = useState("");
  const [topMenuArr, setTopMenuArr] = useState([]);
  const [subMenuArr, setSubMenuArr] = useState([]);
  const [headerDiv, setHeaderDiv] = useState(null);

  useEffect(() => {
    const getPaths = location.pathname.split("/");
    const getFirstPath = getPaths?.[1] ?? "";
    const getSecondPath = getPaths?.[2] ?? "";
    const getThirdPath = getPaths?.[3] ?? "";
    if (getFirstPath !== "") {
      setActiveMenu(getFirstPath);
    }
    if (getSecondPath !== "") {
      setActiveSubMenu(getSecondPath);
    }
    if (getThirdPath !== "") {
      setActiveThirdMenu(getThirdPath);
    }
  }, []);

  useEffect(() => {
    let newSubItems = [];
    let newTopItems = [];
    let newTitle = "";
    let newText = "";
    let headerIcon = "";
    let extraHeaderClass = "";
    let res;
    switch (activeMenu) {
      case "dashboard":
        res = getDashboardHeaderbar(activeMenu, activeSubMenu, activeThirdMenu);
        newSubItems = res.newSubItems;
        newTopItems = res.newTopItems;
        newTitle = res.newTitle;
        newText = res.newText;
        headerIcon = "icon-sprite img_icon_dashboard";
        break;
      case "settings":
        res = getSettingHeaderbar(activeMenu, activeSubMenu, activeThirdMenu);
        newSubItems = res.newSubItems;
        newTopItems = res.newTopItems;
        newTitle = res.newTitle;
        newText = res.newText;
        headerIcon = "icon-sprite img_icon_setting";
        break;
      case "finance":
        res = getFinanceHeaderbar(activeMenu, activeSubMenu, activeThirdMenu);
        newSubItems = res.newSubItems;
        newTopItems = res.newTopItems;
        newTitle = res.newTitle;
        newText = res.newText;
        headerIcon = "icon-sprite img_icon_finance";
        break;
      case "order":
        res = getOrderHeaderbar(activeMenu, activeSubMenu, activeThirdMenu);
        newSubItems = res.newSubItems;
        newTopItems = res.newTopItems;
        newTitle = res.newTitle;
        newText = res.newText;
        headerIcon = "icon-sprite img_icon_orderInvoice";
        break;
      case "labor":
        res = getLaborHeaderbar(activeMenu, activeSubMenu, activeThirdMenu);
        newSubItems = res.newSubItems;
        newTopItems = res.newTopItems;
        newTitle = res.newTitle;
        newText = res.newText;
        headerIcon = "icon-sprite img_icon_labor";
        break;
      case "menu":
        res = getMenuHeaderbar(activeMenu, activeSubMenu, activeThirdMenu);
        newSubItems = res.newSubItems;
        newTopItems = res.newTopItems;
        newTitle = res.newTitle;
        newText = res.newText;
        headerIcon = "icon-sprite img_icon_menuEngineer";
        break;
      case "inventory":
        res = getInventoryHeaderbar(activeMenu, activeSubMenu, activeThirdMenu);
        newSubItems = res.newSubItems;
        newTopItems = res.newTopItems;
        newTitle = res.newTitle;
        newText = res.newText;
        headerIcon = "icon-sprite img_icon_inventory";
        break;
      case "reporting":
        res = getReportingHeaderbar(activeMenu, activeSubMenu, activeThirdMenu);
        newSubItems = res.newSubItems;
        newTopItems = res.newTopItems;
        newTitle = res.newTitle;
        newText = res.newText;
        headerIcon = "icon-sprite i_report";
        break;
      case "onlife":
        res = getOnlifeHeaderbar(activeMenu, activeSubMenu, activeThirdMenu);
        newSubItems = res.newSubItems;
        newTopItems = res.newTopItems;
        newTitle = res.newTitle;
        newText = res.newText;
        headerIcon = "icon-onlife";
        break;
      case "clipboard":
        res = getClipboardHeaderbar(activeMenu, activeSubMenu, activeThirdMenu);
        newSubItems = res.newSubItems;
        newTopItems = res.newTopItems;
        newTitle = res.newTitle;
        newText = res.newText;
        headerIcon = "icon-clipboard";
        extraHeaderClass = "pb-3";
        break;
      case "codes":
        res = getCodesHeaderbar(activeMenu, activeSubMenu, activeThirdMenu);
        newSubItems = res.newSubItems;
        newTopItems = res.newTopItems;
        newTitle = res.newTitle;
        newText = res.newText;
        headerIcon = "icon-sprite img_icon_setting";
        extraHeaderClass = "pb-3";
        break;
      default:
        break;
    }
    setTopMenuArr(newTopItems);
    setSubMenuArr(newSubItems);
    setHeaderDiv(
      <div className={`col px-0 d-flex ${extraHeaderClass}`}>
        <i className={headerIcon}></i>
        <div class="pageHeading">
          <span className="text-uppercase">{newTitle} </span>
          {newText !== "" && (
            <>
              <i className="icon-arrow-fo"></i>
              <span>{newText}</span>
            </>
          )}
        </div>
      </div>
    );
  }, [activeMenu]);

  let res = (
    <>
      <div className="bg_white_full">
        <div className="container px-0">
          <div className="inner_content">
            <div className="main-top-bar statistic clearfix">
              <div className="current_page pull_left pt-3 pb-0">
                {headerDiv}
                <ul className="right_corner m-0" style={{ display: "none" }}>
                  <li>
                    <form
                      action="/users/switch_merchant"
                      className=""
                      id="storeSelecterForm"
                      method="post"
                      accept-charset="utf-8"
                    ></form>
                  </li>
                  <li>
                    <a>
                      <i className="img_message"></i>
                    </a>
                    <a className="notify-icon" id="notify-icon-1">
                      31
                    </a>
                  </li>
                  <li>
                    <a href="#_">
                      <i className="img_logout"></i>
                    </a>
                  </li>
                </ul>
              </div>
              <div className="top_tab_menu">
                <ul className="top_tab_menu_ul px-0 m-0">
                  {topMenuArr &&
                    topMenuArr.length > 0 &&
                    topMenuArr.map((topItem) => {
                      return (
                        <li className={topItem.class}>
                          <a
                            onClick={() => {
                              if (topItem?.path) history.push(topItem?.path);
                            }}
                          >
                            {topItem.title}
                          </a>
                        </li>
                      );
                    })}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      {subMenuArr && subMenuArr.length > 0 && (
        <div className="bg_white_dark">
          <div className="container px-0">
            <div className="inner_content">
              <div className="row-fluid hidden-print">
                <div className="span12">
                  <ul className="steps">
                    {subMenuArr.map((subItem) => {
                      return (
                        <li className={subItem.class}>
                          <a
                            className="link"
                            role="button"
                            onClick={() => {
                              if (subItem?.path) history.push(subItem?.path);
                            }}
                          >
                            {subItem.title}
                          </a>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
  return res;
};
export default Headerbar;
